import { render, staticRenderFns } from "./CameraItem.vue?vue&type=template&id=15a64e82&scoped=true&"
import script from "./CameraItem.vue?vue&type=script&lang=ts&"
export * from "./CameraItem.vue?vue&type=script&lang=ts&"
import style0 from "./CameraItem.vue?vue&type=style&index=0&id=15a64e82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a64e82",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
